import React from "react";
import {useHistory} from "react-router-dom";
import {ROUTES} from "../../db/models/const";
import "./style.scss";

const NotFound = () => {
    const history = useHistory();

    const handleGoHome = () => {
        history.push(ROUTES.STUDENT_HOME);
    }

    return (
        <div className="notFound container">
            <h2>404 Not Found</h2>
            <button onClick={handleGoHome}>Home</button>
        </div>
    );
};

export default NotFound;
